export default __webpack_public_path__ + "static/media/HeroBackground@lg.b594e286.jpg";